import React, { useState, useEffect } from 'react'

const TextResizeButton = () => {
  const [isLarge, setIsLarge] = useState(false)

  useEffect(() => {
    // Get initial zoom level from localStorage or default to 100%
    const savedZoom = localStorage.getItem('textZoom') || 100
    const isLargeText = savedZoom === 115
    setIsLarge(isLargeText)
    applyZoom(isLargeText ? 115 : 100)
  }, [])

  const applyZoom = (zoomLevel) => {
    // Apply zoom using CSS transform on the body
    document.body.style.zoom = zoomLevel / 100
    // Alternative approach using CSS transform if zoom is not supported
    if (document.body.style.zoom === undefined) {
      document.body.style.transform = `scale(${zoomLevel / 100})`
      document.body.style.transformOrigin = 'top left'
    }
    localStorage.setItem('textZoom', zoomLevel.toString())
  }

  const handleToggle = () => {
    const newIsLarge = !isLarge
    setIsLarge(newIsLarge)
    applyZoom(newIsLarge ? 120 : 100)
  }

  return (
    <div
      onClick={handleToggle}
      style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: '2px',
        cursor: 'pointer',
        paddingLeft: '1.25rem',
        userSelect: 'none',
        fontFamily: 'Courier, monospace',
      }}
      title={isLarge ? 'Switch to small text' : 'Switch to large text'}
    >
      <span
        style={{
          fontSize: '14px',
          fontWeight: 'bold',
          color: isLarge ? 'rgba(0, 0, 0, 0.2)' : '#495057',
          transition: 'color 0.2s ease',
        }}
      >
        T
      </span>
      <span
        style={{
          fontSize: '18px',
          fontWeight: 'bold',
          color: isLarge ? '#495057' : 'rgba(0, 0, 0, 0.2)',
          transition: 'color 0.2s ease',
        }}
      >
        T
      </span>
    </div>
  )
}

export default TextResizeButton
